// Google Analytics 4 utilities
let initialized = false;

// Real GA4 Measurement ID for Downes Engineering
const GA4_MEASUREMENT_ID = 'G-86QHBS6L9B';

export const initGA = () => {
  if (initialized || typeof window === 'undefined') return;
  
  // Initialize GA4
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA4_MEASUREMENT_ID, {
    send_page_view: false, // We'll track manually for SPA
  });
  
  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
  document.head.appendChild(script);
  
  initialized = true;
  console.log('✓ GA4 Analytics initialized with ID:', GA4_MEASUREMENT_ID);
};

export const trackPageView = (path, title = document.title) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_title: title,
      page_location: window.location.href,
      page_path: path,
    });
  }
};

export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, parameters);
  }
};

// Predefined event trackers
export const trackCTAClick = (ctaName, ctaLocation, destination) => {
  trackEvent('cta_click', {
    cta_name: ctaName,
    cta_location: ctaLocation,
    destination: destination,
  });
};

export const trackNavigation = (linkName, destination) => {
  trackEvent('navigation_click', {
    link_name: linkName,
    destination: destination,
  });
};

export const trackOutboundLink = (linkType, linkLabel, destinationDomain) => {
  trackEvent('outbound_link_click', {
    link_type: linkType,
    link_label: linkLabel,
    destination_domain: destinationDomain,
  });
};

export const trackFormSubmission = (formName, success = true) => {
  if (success) {
    trackEvent('generate_lead', {
      form_name: formName,
    });
  } else {
    trackEvent('form_error', {
      form_name: formName,
    });
  }
};

export const trackServiceInquiry = (serviceName, sourcePage) => {
  trackEvent('service_inquiry', {
    service_name: serviceName,
    source_page: sourcePage,
  });
};
